<!-- partial:index.partial.html -->
<h3 class ="lead">Popular</h3>
<div class="row">
  <div *ngFor="let item of popular" style="padding-left: 10px; padding-top: 10px;">
    <div class="mobile-card"  ngbPopover="Click More For Details!"  placement="right" triggers="mouseenter:mouseleave" popoverTitle="{{item.title}}">
      <img src="{{item.image}}" alt="{{item.title | lowercase}}">
      <div class="card-content">
        <div class="card-info">
          <h3>{{item.title}}</h3>
        </div>
        <div class="card-action">
          <span>More</span>
          <a class="stretched-link" [routerLink]="['/details',item.id]" routerLinkActive="router-link-active"> <i
            class="fa fa-arrow-right"></i></a>
        </div>
      </div>
    </div>
  </div>
  <!-- partial -->
</div>
<div class="contaier">
  <button class="btn btn-dark rounded-pill-lg">

      Next

  </button>
</div>
